import { render, staticRenderFns } from "./onebox-trash.vue?vue&type=template&id=38c5c8dc&"
import script from "./onebox-trash.vue?vue&type=script&lang=js&"
export * from "./onebox-trash.vue?vue&type=script&lang=js&"
import style0 from "./onebox-trash.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports